import React, { useState, useEffect } from 'react';
import { observacaoDoCliente } from '../services/mysuiteApi';
import Icon from './Icon';

// ─────────────────────────────────────────────────────────────────────────────
// Observações do cliente — o campo de texto livre do cadastro no MySuite
// (dados de conexão, acessos, particularidades), pelo CNPJ do ticket.
//
// Começa RECOLHIDO e só consulta ao abrir. O texto é longo (passa de 2 mil
// caracteres em alguns clientes) e nem todo atendimento precisa dele: aberto
// por padrão, empurraria o resto do ticket para baixo; carregado sem pedido,
// seria uma consulta a cada ticket aberto.
//
// Trocar de ticket recolhe de novo: a observação aberta é a do cliente
// anterior, e mostrá-la sob outro ticket seria pior do que não mostrar nada.
// ─────────────────────────────────────────────────────────────────────────────

export default function ObservacaoCliente({ cnpj }) {
  const [aberto, setAberto] = useState(false);
  // undefined = ainda não consultou; null = falhou; '' = não há; texto = há.
  const [texto, setTexto] = useState(undefined);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => { setAberto(false); setTexto(undefined); }, [cnpj]);

  if (!cnpj) return null;

  const consultar = async () => {
    setCarregando(true);
    try {
      setTexto(await observacaoDoCliente(cnpj));
    } finally {
      setCarregando(false);
    }
  };

  const alternar = () => {
    const abrir = !aberto;
    setAberto(abrir);
    // Consulta na primeira abertura e de novo depois de uma falha.
    if (abrir && (texto === undefined || texto === null)) consultar();
  };

  let corpo;
  if (carregando) {
    corpo = (
      <div className="campo-dica">
        <Icon name="rotate-cw" size={13} className="orion-spin" /> Consultando o MySuite…
      </div>
    );
  } else if (texto === null) {
    corpo = (
      <div className="campo-dica">
        Não deu para consultar as observações agora.{' '}
        <button type="button" className="btn btn-ghost btn-sm" onClick={consultar}>Tentar de novo</button>
      </div>
    );
  } else if (texto === '') {
    corpo = <div className="campo-dica">Este cliente não tem observações cadastradas.</div>;
  } else {
    corpo = <div className="obs-cliente-texto">{texto}</div>;
  }

  return (
    <div className="obs-cliente">
      <button
        type="button"
        className="obs-cliente-cab"
        onClick={alternar}
        aria-expanded={aberto}
      >
        <Icon name={aberto ? 'chevron-down' : 'chevron-right'} size={14} />
        <Icon name="file-text" size={14} />
        <span>Observações do cliente</span>
      </button>
      {aberto && <div className="obs-cliente-corpo">{corpo}</div>}
    </div>
  );
}
